export const ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST = 'ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST';
export const ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST_SUCCEEDED = 'ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST_SUCCEEDED';
export const ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST_FAILED = 'ENROLLMENT_SPLIT_PAYMENT_CONFIRM_EXPORTAR_REQUEST_FAILED';
